/**
 * Fisher–Yates shuffle, non-mutating.
 * Used by gallery pages to randomize photo order per visit.
 */
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const importAll = (r) => r.keys().map(r);
